/* eslint-disable @typescript-eslint/no-unused-vars */
import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import './index.css'
import App from './App'

Sentry.init({
  dsn: import.meta.env.VITE_REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  
  // Set tracesSampleRate to control what percentage of transactions are captured
  tracesSampleRate: parseFloat(import.meta.env.VITE_REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '1.0'),
  
  // Set tracePropagationTargets to control which URLs distributed tracing should be enabled for
  tracePropagationTargets: JSON.parse(import.meta.env.VITE_REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS || '["https://referral.hellolunajoy.com"]'),
  
  // Set environment from environment variable
  environment: import.meta.env.VITE_REACT_APP_CLIENT_ENV,
  
  // Set enabled flag explicitly to ensure it's properly enabled
  enabled: import.meta.env.VITE_REACT_APP_SENTRY_ENABLED === 'yes',
  
  // Add app-specific tag for better tracking
  initialScope: {
    tags: {
      appName: 'referrals-client',
    },
  },
});

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
      <App />
  );
}
